import { createApp, nextTick } from 'vue';
import toastComponent from './toast.vue';

function showToast(text, duration = 3000, style = {}, isWeb = false) {
    const app = createApp({
        ...toastComponent,
        data() {
            return {
                text: text,
                showWrap: true,
                showContent: true,
                isWeb,
                style,
            };
        },
        mounted() {
            nextTick(() => {
                setTimeout(() => {
                    this.showContent = false;
                }, duration - 1250);
                setTimeout(() => {
                    this.showWrap = false;
                }, duration);
            });
        }
    });

    app.mount(document.createElement('div'));
}

export default {
    install(app){
        app.config.globalProperties.$toast = showToast;
    }
};